"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBreakpoint = useBreakpoint;

var _styles = require("react-components/styles");

var _mediaQuery = require("@slyk/media-query");

/**
 * Module dependencies.
 */

/**
 * Get breakpoint value.
 */
function getBreakpointValue(breakpoint, type) {
  var value = _styles.breakpoints[breakpoint];
  return type === 'max' ? value - 1 : value;
}
/**
 * Export `useBreakpoint` hook.
 */


function useBreakpoint(breakpoint) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'min';
  var breakpointValue = getBreakpointValue(breakpoint, type);
  var query = "(".concat(type, "-width: ").concat(breakpointValue, "px)");
  return (0, _mediaQuery.useMediaQuery)(query);
}